"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const prop_types_1 = __importDefault(require("prop-types"));
const uuid_1 = require("uuid");
// eslint-disable-next-line import/no-extraneous-dependencies
const plds_tokens_1 = require("@paclife/plds.tokens");
const rippleAnimation = styled_components_1.keyframes `
  from {
    opacity: 0.75;
    transform: scale(0);
  }

  to {
    opacity: 0;
    transform: scale(2);
  }
`;
const RippleContainer = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  span {
    transform: scale(0);
    border-radius: ${plds_tokens_1.Radii.circle};
    position: absolute;
    opacity: 0.25;
    background-color: ${(props) => props.color};
    animation: ${rippleAnimation} ${(props) => props.duration}ms;
  }
`;
const useEnhancedEffect = typeof window === "undefined" ? react_1.default.useEffect : react_1.default.useLayoutEffect;
const useDebouncedRippleCleanUp = (rippleCount, duration, cleanUpFunction) => {
    useEnhancedEffect(() => {
        let bounce = null;
        if (rippleCount > 0) {
            clearTimeout(bounce);
            bounce = setTimeout(() => {
                cleanUpFunction();
                clearTimeout(bounce);
            }, duration * 4);
        }
        return () => clearTimeout(bounce);
    }, [rippleCount, duration, cleanUpFunction]);
};
const Ripple = ({ duration, color }) => {
    const [rippleArray, setRippleArray] = react_1.useState([]);
    const addRipple = (event) => {
        const rippleContainer = event.currentTarget.getBoundingClientRect();
        const size = rippleContainer.width > rippleContainer.height ? rippleContainer.width : rippleContainer.height;
        const x = event.clientX - rippleContainer.x - size / 2;
        const y = event.clientY - rippleContainer.y - size / 2;
        const newRipple = {
            x,
            y,
            size,
            key: uuid_1.v4(),
        };
        setRippleArray([...rippleArray, newRipple]);
    };
    useDebouncedRippleCleanUp(rippleArray.length, duration, () => {
        setRippleArray([]);
    });
    return (react_1.default.createElement(RippleContainer, { duration: duration, color: color, onMouseDown: addRipple }, rippleArray.length > 0 &&
        rippleArray.map((ripple) => (react_1.default.createElement("span", { key: ripple.key, style: {
                top: ripple.y,
                left: ripple.x,
                width: ripple.size,
                height: ripple.size,
            } })))));
};
Ripple.propTypes = {
    duration: prop_types_1.default.number,
    color: prop_types_1.default.string,
};
Ripple.defaultProps = {
    duration: plds_tokens_1.Durations.long * 1000,
    color: plds_tokens_1.Colors.neutral500,
};
exports.default = Ripple;
//# sourceMappingURL=Ripple.js.map